import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2 18h10v-2H2v2zm11-5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V6c0-.297.132-.578.359-.769l6-5a1.005 1.005 0 0 1 1.282 0l6 5c.423.354.481.985.128 1.41-.354.423-.983.48-1.41.128L7 2.302 2 6.469V14h10a1 1 0 0 1 1-1zM6 6a1 1 0 1 1 2 0 1 1 0 1 1-2 0zm13 3a1 1 0 1 1 0 2h-2v2a1 1 0 1 1-2 0v-2h-2a1 1 0 1 1 0-2h2V7a1 1 0 1 1 2 0v2h2z"
});

var SvgAddProductMajorMonotone = function SvgAddProductMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgAddProductMajorMonotone as S };